import Vue from 'vue'
import VueRouter from 'vue-router'
import memberHome from '@/components/memberHome'
import activityIndex from '@/components/member/activities/activityIndex'
import mine from '@/components/member/mine/mine'
import login from '@/views/login'
import Dtask from '@/views/Dtask'
import Ttask from '@/views/Ttask'
import Ttaskwai from '@/views/Ttaskwai'
import Shouye from '@/views/Shouye'
import Tupload from '@/views/Tupload'
import studyRanking from '@/views/studyRanking'
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    //路由映射map
    routes: [
      { path: '/', redirect: '/login' },
      { path: '*', redirect: '/memberHome/dashbord' },
      { path: '/login', component: login },
      {
        path: '/dtask',
        name: 'Dtask',
        component: Dtask
      },
      {
        path: '/ttask',
        name: 'Ttask',
        component: Ttask
      },
      {
        path: '/ttaskwai',
        name: 'Ttaskwai',
        component: Ttaskwai
      },
      {
        path: '/studyRanking',
        name: 'studyRanking',
        component: studyRanking
      },
      {
        path: '/shouye',
        name: 'Shouye',
        component: Shouye
      },
      {
        path: '/tupload',
        name: 'Tupload',
        component: Tupload
      },
    
	    {
	      path: '/memberHome',
	      name: 'memberHome',
	      component: memberHome,
	      children:[
	      	{
			      path: '/memberHome/dashbord',
			      name: 'dashbord',
			      component: activityIndex
			    },
			    {
			      path: '/memberHome/mine',
			      name: 'mine',
			      component: mine
			    },

	      ]
	    },

    ]



});
router.beforeEach((to, from, next) => {
  console.log(1)
  console.log(to)
  console.log(1)
  console.log(from.fullPath)
  console.log(2)
  console.log(sessionStorage.getItem("wxid"))
  if(from.fullPath === '/' || to.fullPath === '/Tupload' || to.fullPath === '/Ttaskwai'|| to.fullPath === '/shouye'){
      next()
  }else{
    if(localStorage.getItem('wxid')=== null){
      alert('无权查看')
      
    }else{
      next()
    }
  }
 

})






export default router;



// WEBPACK FOOTER //
// ./src/router/memberRouter.js